"use client";
import * as React from "react";
import { useState } from "react";
import { UserIcon } from "./UserIcon";

export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);

  const handleScrollToPlans = () => {
    const el = document.getElementById("nossos-planos");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="d-md-none position-relative">
      <button
        onClick={toggleMenu}
        className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
        style={{
          width: '40px',
          height: '40px',
          border: '1px solid #dee2e6'
        }}
        aria-label="Menu"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 12H21M3 6H21M3 18H21"
            stroke="#374151"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <>
          <div
            className="position-fixed w-100 h-100"
            style={{
              top: 0,
              left: 0,
              zIndex: 1040
            }}
            onClick={toggleMenu}
          />
          <div
            className="position-absolute bg-white border rounded shadow"
            style={{
              right: 0,
              top: '48px',
              zIndex: 1050,
              width: '200px',
              padding: '0.5rem 0'
            }}
          >
            {/* Meu Acesso */}
            <button
              onClick={() => {
                window.open('https://nacaosaude.centraldeatendimento.me/login', '_blank');
                toggleMenu();
              }}
              className="btn w-100 d-flex align-items-center text-start"
              style={{
                gap: '10px',
                padding: '12px 16px',
                border: 'none',
                backgroundColor: 'transparent'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <UserIcon />
              <span
                className="fw-bold"
                style={{
                  color: '#2AAE3F',
                  fontSize: '16px'
                }}
              >
                Meu Acesso
              </span>
            </button>

            {/* Rede Credenciada */}
            <button
              onClick={() => {
                window.open('https://nacaosaude.centraldeatendimento.me/redecredenciada', '_blank');
                toggleMenu();
              }}
              className="btn w-100 d-flex align-items-center text-start"
              style={{
                gap: '10px',
                padding: '12px 16px',
                border: 'none',
                backgroundColor: 'transparent'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <UserIcon />
              <span
                className="fw-bold"
                style={{
                  color: '#2AAE3F',
                  fontSize: '16px'
                }}
              >
                Rede Credenciada
              </span>
            </button>

            {/* Meu Clube */}
            <button
              onClick={() => {
                window.open('https://nacaosaude.clubeparcerias.com.br', '_blank');
                toggleMenu();
              }}
              className="btn w-100 d-flex align-items-center text-start"
              style={{
                gap: '10px',
                padding: '12px 16px',
                border: 'none',
                backgroundColor: 'transparent'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <UserIcon />
              <span
                className="fw-bold"
                style={{
                  color: '#2AAE3F',
                  fontSize: '16px'
                }}
              >
                Meu Clube
              </span>
            </button>

            {/* Peça já o seu */}
            <button
              onClick={() => {
                handleScrollToPlans();
                toggleMenu();
              }}
              className="btn w-100 d-flex align-items-center text-start"
              style={{
                gap: '10px',
                padding: '12px 16px',
                border: 'none',
                backgroundColor: 'transparent'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <div
                className="d-flex align-items-center justify-content-center rounded"
                style={{
                  width: '18px',
                  height: '18px',
                  backgroundColor: '#2AAE3F'
                }}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 5V19M5 12H19"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span
                className="fw-bold"
                style={{
                  color: '#2AAE3F',
                  fontSize: '16px'
                }}
              >
                Peça já o seu
              </span>
            </button>
          </div>
        </>
      )}
    </div>
  );
}